export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_305d3ca8-4ec1-4217-97b3-db28c176cc65/artifacts/b4o7ig70_2026-06-01%2021.52.29.jpg";

export const REALISATIONS = [
  {
    url: "https://customer-assets.emergentagent.com/job_bgtp-excavation/artifacts/gvnc6a8h_2026-06-01%2022.36.55.jpg",
    title: "Avant / Après — Cour gravillonnée",
    tag: "Aménagement extérieur",
    location: "Ain (01)",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_bgtp-excavation/artifacts/4q2yh0jf_2026-06-01%2022.37.20.jpg",
    title: "Murêt pierre & cour en gravillons",
    tag: "Maçonnerie · Création de cour",
    location: "Ain (01)",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_bgtp-excavation/artifacts/9qakrkti_2026-06-01%2022.37.24.jpg",
    title: "Cour bi-ton — gris & beige",
    tag: "Aménagement extérieur",
    location: "Ain (01)",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_bgtp-excavation/artifacts/3pd7p0zv_2026-06-01%2022.37.12.jpg",
    title: "Terrassement & préparation de cour",
    tag: "Terrassement",
    location: "Chantier privé",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_bgtp-excavation/artifacts/iz138b30_2026-06-01%2022.37.15.jpg",
    title: "Pose de pavés & préparation du sol",
    tag: "Aménagement extérieur",
    location: "Chantier privé",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_305d3ca8-4ec1-4217-97b3-db28c176cc65/artifacts/a183unym_2026-06-01%2021.52.43.jpg",
    title: "Cour en gravillons & bordure pierre",
    tag: "Création de cour",
    location: "Saint-Didier-sur-Chalaronne",
  },
];

export const PHONE = "07 68 41 41 36";
export const PHONE_TEL = "+33768414136";
export const EMAIL = "bg.terrassement01@gmail.com";
export const LOCATION = "Saint-Didier-sur-Chalaronne (01)";
export const AREA = "Ain (01) & environs";

export const SERVICES = [
  {
    key: "terrassement",
    title: "Terrassement",
    icon: "Truck",
    points: [
      "Préparation de terrain",
      "Creusement de tranchées",
      "Fondations & fouilles",
      "Nivellement & remblais",
    ],
  },
  {
    key: "amenagement",
    title: "Aménagement Extérieur",
    icon: "Trees",
    points: [
      "Allées, cours & accès",
      "Terrasses & bordures",
      "Création de cour",
      "Jardins & espaces verts",
    ],
  },
  {
    key: "renovation",
    title: "Rénovation",
    icon: "HardHat",
    points: [
      "Maçonnerie générale",
      "Plâtrerie & peinture",
      "Revêtements & finitions",
      "Tous types de rénovation",
    ],
  },
];

export const REASONS = [
  { title: "Travail soigné", desc: "Chantiers menés avec rigueur, finitions propres et respect des règles de l'art." },
  { title: "Respect des délais", desc: "Planning tenu, communication claire, livraison à date convenue." },
  { title: "Intervention rapide", desc: "Devis sous 48h, démarrage de chantier dans des délais courts." },
  { title: "Devis gratuit", desc: "Étude personnalisée et transparente, sans engagement." },
];

export const TESTIMONIALS = [
  {
    name: "Julien M.",
    city: "Thoissey",
    rating: 5,
    text: "Cour entièrement refaite en gravillons avec bordures pierre. Travail propre, équipe sérieuse et délais respectés. Je recommande !",
  },
  {
    name: "Sandra & Pierre L.",
    city: "Saint-Didier-sur-Chalaronne",
    rating: 5,
    text: "Terrassement et création d'une allée d'accès. Devis clair, prix juste et chantier impeccable. Très professionnel.",
  },
  {
    name: "Mathieu R.",
    city: "Mâcon",
    rating: 5,
    text: "Rénovation extérieure + aménagement jardin. Du conseil au rendu final, tout a été parfait. Merci à toute l'équipe BGTP.",
  },
];

// Zones d'intervention — Ain (01) & alentours / Saône-et-Loire frontaliers
export const INTERVENTION_ZONES = [
  "Saint-Didier-sur-Chalaronne",
  "Thoissey",
  "Mogneneins",
  "Saint-Étienne-sur-Chalaronne",
  "Châtillon-sur-Chalaronne",
  "Montceaux",
  "Guéreins",
  "Genouilleux",
  "Belleville-en-Beaujolais",
  "Mâcon",
  "Crêches-sur-Saône",
  "Pont-de-Veyle",
  "Vonnas",
  "Bourg-en-Bresse",
  "Trévoux",
  "Villefranche-sur-Saône",
  "Romanèche-Thorins",
  "Replonges",
];
